import React from 'react'

import './chevron.scss'

export default ({ amount = 1 }) => {
  const renderChevrons = () => {
    const chevrons = []
    for (let i = 0; i < amount; i++) {
      chevrons.push(
        <div
          key={i}
          className="chevron"
          style={{ transform: `rotate(-90deg) translateY(${140 * i}%)` }}
        />
      )
    }
    return chevrons
  }

  return <div className="chevron-container">{renderChevrons()}</div>
}
